import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { ISettingsState }       from 'Redux/Slices/Settings/SettingsSlice';
import { Location }             from 'Domain/Models';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const updateSettingsRequest = (state: Draft<ISettingsState>, { type }: PayloadAction<{ formData: Record<string, unknown> }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const updateSettingsSuccess = (state: Draft<ISettingsState>, { type, payload }: PayloadAction<{
  options: Record<string, unknown>
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = { ...state.entries, ...payload.options };
};

export const updateSettingsFailure = (state: Draft<ISettingsState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
